import React from 'react'

export const FirebaseContext = React.createContext()

export const FirebaseProvider = FirebaseContext.Provider
export const FirebaseConsumer = FirebaseContext.Consumer
